import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

const base =
  "inline-flex items-center justify-center gap-2 font-semibold uppercase tracking-wide rounded-md transition-all duration-300 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-signature focus-visible:ring-offset-2 focus-visible:ring-offset-ink-900";

const variants = {
  primary:
    "bg-signature hover:bg-[#ff4a52] text-white shadow-lg shadow-signature/30 hover:shadow-signature/50",
  secondary:
    "bg-ink-700/80 hover:bg-ink-600 text-white border border-chrome-dark hover:border-chrome-mid",
  ghost: "text-chrome-light hover:text-white hover:bg-white/5",
  outline:
    "border border-white/20 text-white hover:border-signature hover:text-signature bg-transparent",
};

const sizes = {
  md: "py-3 px-6 text-sm",
  lg: "py-4 px-8 text-sm sm:text-base",
  sm: "py-2 px-4 text-xs",
};

export const Btn = ({ to, href, variant = "primary", size = "md", className, children, ...rest }) => {
  const cls = cn(base, variants[variant], sizes[size], className);
  if (to) return <Link to={to} className={cls} {...rest}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...rest}>{children}</a>;
  return <button className={cls} {...rest}>{children}</button>;
};

export const Overline = ({ children, className }) => (
  <span className={cn("inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.25em] text-signature font-semibold", className)}>
    <span className="h-px w-6 bg-signature" />
    {children}
  </span>
);
